import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface IAuthStore {
  isAfterAuthCheck: boolean; // Флаг, который показывает, что пользователь прошел проверку в Private и Public Routes и он либо авторизован, либо нет.
  setIsAfterAuthCheck: (isAfterAuthCheck: boolean) => void;
}

export const useAuthStore = createWithEqualityFn<IAuthStore>()(
  devtools(
    (set) => ({
      isAfterAuthCheck: false,
      setIsAfterAuthCheck: (isAfterAuthCheck: boolean) => {
        set({ isAfterAuthCheck });
      },
    }),
    { name: "Auth Store" },
  ),
  shallow,
);
